// ============================================================================
// psyRenderer.tsx — ПРИЛОЖЕНИЕ «Психолог» (appKind/code 'psy', модуль
// hydra.medic.psy). Module-owned: серверный объект kind='app' создаёт поставка,
// pkg.Apply включает его в воркспейс «Предприятие». Доступ — роль «Психолог»/
// «Психолог-стажёр» (или администратор); данные защищены правами объектов.
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { PsyWorkspace } from '@/components/psy/PsyWorkspace';
import { PSY_ROLE, PSY_INTERN_ROLE } from '@/lib/psyWorkspace';
import { useSecurityAccess } from '@/lib/securityRoles';
import { useI18n } from '@/lib/i18n/I18nProvider';

export const PSY_APP_CODE = 'psy';
export const PSY_APP_KIND = 'psy';

function PsyApp() {
    const { t } = useI18n();
    const access = useSecurityAccess();
    const allowed = access.isAdmin || access.roles.includes(PSY_ROLE) || access.roles.includes(PSY_INTERN_ROLE);
    if (!allowed) {
        return (
            <div className="h-full flex items-center justify-center p-6">
                <div className="max-w-md text-center space-y-2">
                    <div className="text-sm font-medium">{t('psy.app_unavailable')}</div>
                    <div className="text-xs text-muted-foreground">
                        {t('psy.app_unavailable_hint')}
                    </div>
                </div>
            </div>
        );
    }
    return <PsyWorkspace />;
}

/** Манифест приложения (AppHost): module-owned, на весь воркспейс. */
export const PSY_APP_MANIFEST: AppManifest = {
    code: PSY_APP_CODE,
    name: 'Psy',
    synonym: 'Психолог',
    appKind: PSY_APP_KIND,
    area: 'full',
    apiVersion: APPSDK_VERSION,
    permissions: ['data:read', 'data:write', 'settings:app'],
};

export function registerPsyApp(): void {
    registerAppRenderer({
        appKind: PSY_APP_KIND,
        code: PSY_APP_CODE,
        title: 'Психолог',
        Component: PsyApp,
        manifest: PSY_APP_MANIFEST,
    });
}
